import React from 'react';
import CreateView from '../components/CreateView';

const InvoicesCreate = () => <CreateView invoice_type="invoice" title="Create Invoices" />;

export default InvoicesCreate;
